import { NgComponentOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { CmsComponent } from '@app/core/models/atomics.model';
import { CxAbstractRenderBase } from '@b2b/components/cms/cx-abstract/cx-abstract-render-base';
import { CX_ABSTRACT_COMPONENT, CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { CxAbstractComponentProvider } from '@b2b/components/cms/cx-abstract/cx-abstract.types';

@Component({
  selector: 'cx-abstract',
  templateUrl: './cx-abstract.component.html',
  imports: [NgComponentOutlet],
})
export class CxAbstractComponent extends CxAbstractRenderBase<CmsComponent> {
  readonly component = input.required<CmsComponent>();

  override readonly renderers = this.baseInjector.get(CX_ABSTRACT_COMPONENT, []);
  override readonly input = this.component;

  protected override matchRenderer(input: any, renderer: CxAbstractComponentProvider): boolean {
    return input?.type === renderer?.type;
  }

  protected override createProviders(input: any) {
    return [
      {
        provide: CX_ABSTRACT_COMPONENT_DATA,
        useValue: input?.data,
      },
    ];
  }
}
